import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Inject } from '@angular/core';
import { environment } from 'src/environments/environment';
import { FlashMessageService } from 'src/app/shared/services/flash-message.service';
import { ModalService } from 'src/app/shared/services/modal.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics/google-analytics.service';

@Component({
  selector: 'delete-user',
  templateUrl: './delete-user.component.html',
  styleUrls: ['./delete-user.component.scss']
})
export class DeleteUserComponent implements OnInit {
  public loading: boolean = false;
  public userUrl = environment.runtime.userManagementApiUrl;

  constructor(
    private authHttp: HttpClient,
    private _gaSvc: GoogleAnalyticsService,
    private flashMessageService: FlashMessageService,
    private modal: ModalService,
    @Inject(MAT_DIALOG_DATA) public user: any
  ) { }

  ngOnInit() {
  }


  public delete() {
    this.loading = true;
    this.authHttp.delete(`${this.userUrl}/user/delete/${this.user._id}`)
      .toPromise()
      .then((response: any) => {
        this._gaSvc.register(`Admin deleted a user` , this.user.organizationName);
        if(response['status'] === 'User Deleted') {
          this.flashMessageService.updateMessage("User successfully deleted.", 3000, "success");
          this.close(this.user);
        } else {
          this.close();
        }
        this.loading = false;
      }).catch(e => {
        this.loading = false;
        this.flashMessageService.updateMessage("User was not deleted.", 3000, "danger");
        this.close();
      })
  }

  public close(data = null) {
    this.modal.close(data);
  }
}
